/* eslint-disable ember/no-classic-components */
import { tagName } from '@ember-decorators/component';
import Component from '@ember/component';

@tagName('')
export default class AttendanceReportBarChart extends Component {
  codeColors = Object.freeze([
    '#12681f', // Blue 800
    '#D84315', // Deep Orange 800
    '#FF8F00', // Amber 800
    '#00b2fc', // Green 800
    '#6A1B9A', // Purple 800
    '#00ACC1', // Cyan 600
    '#E91E63', // Pink 500
    '#226089', // Lime 800
    '#249e94', // Lime 800
    '#d4d3a9', // Lime 800
    '#d2a6cd', // Lime 800
    '#933535', // Lime 800
    '#9ae382', // Lime 800
  ]);

  /** attrs **/
  // barClicked is called when a chart bar is clicked.
  barClicked() {}

  // height specifies the height of the chart.
  height = 150;

  // width specifies the width of the chart.
  width = 220;

  // title specifies the chart title.
  title = '';
}
